enum PaymentType {
  cheque = 'Cheque',
  usBank = 'US Bank',
  ETransfer = 'E-Transfer',
}
export default PaymentType;
